/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicScheduleRecommendation extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicScheduleRecommendation");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicScheduleRecommendation.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicScheduleRecommendation>): BackgroundJobPayloadForPeriodicScheduleRecommendation {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicScheduleRecommendation(), model);
        BackgroundJobPayloadForPeriodicScheduleRecommendation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicScheduleRecommendation>): BackgroundJobPayloadForPeriodicScheduleRecommendation {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicScheduleRecommendation.newInstance(<BackgroundJobPayloadForPeriodicScheduleRecommendation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicScheduleRecommendation) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicScheduleRecommendation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicScheduleRecommendation): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicScheduleRecommendation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
